import { useKeymap } from "@features/keymap/useKeymap"
import { KeyBinding } from "@features/keymap/KeyBinding"
import { MinusIcon } from "@components/Icons/Minus"
import { ControlButton, useReactFlow } from "reactflow"
import { shortcuts } from "@features/keymap/shortcuts"

export const ZoomOutButton = () => {
  const reactFlowInstance = useReactFlow()
  const keymap = useKeymap()

  const handleZoomOut = () => reactFlowInstance.zoomOut()

  return (
    <>
      <KeyBinding bind={shortcuts["zoom-out"]} onKeyDown={handleZoomOut} allowRepeat />
      <ControlButton
        data-testid="graph-controls-zoom-out-btn"
        onClick={handleZoomOut}
        title={keymap.getKeymaps().byId.get("zoom-out")?.desc}
      >
        <MinusIcon />
      </ControlButton>
    </>
  )
}
